import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { version } from "../../environments/environment";
import { Schedule } from '../survey.Service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.css']
})
export class TermsOfServiceComponent implements OnInit {

  schedule: Schedule = new Schedule("", false, new Date(), new Date(), "");
  currentVersion: string;
  currentYear = new Date().getFullYear();

  constructor(private breakpointObserver: BreakpointObserver,
    private router: Router) {
    this.currentVersion = version;
  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  ngOnInit(): void {
  }

  openTerms() {
    const url = this.router.createUrlTree(['/termsofservice']);
    window.open(url.toString(), '_blank');
  }

  openPrivacy() {
    const url = this.router.createUrlTree(['/privacystatement']);
    window.open(url.toString(), '_blank');
  }

}
